import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { exchangeCodeForTokens } from "../lib/auth";

export const Route = createFileRoute("/auth/callback")({
  component: AuthCallback,
});

function AuthCallback() {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const verifier = sessionStorage.getItem("code_verifier");

    if (!code || !verifier) {
      setError("コードまたはベリファイアが見つかりません");
      return;
    }

    exchangeCodeForTokens(code, verifier)
      .then(() => {
        sessionStorage.removeItem("code_verifier");
        navigate({ to: "/" });
      })
      .catch((e: Error) => {
        setError(e.message);
      });
  }, [navigate]);

  if (error) {
    return (
      <div className="rounded-xl bg-red-50 border border-red-200 p-4 text-sm text-red-700">
        ログインに失敗しました: {error}
      </div>
    );
  }

  return <p className="text-neutral-500">ログイン処理中...</p>;
}
